// hooks/useRoleManager.ts
import {
  PermissionType,
  RolePermission,
  UpdateRolePermissionPayload,
} from "constants/types/permission";
import { set } from "lodash";
import { useState, useEffect } from "react";
import {
  GroupedPermissions,
  groupPermissionsByModule,
} from "utils/helpers/permission";

interface UseRoleManagerProps {
  role: string;
  allPermissions: PermissionType[];
  currentRolePermissions: RolePermission[];
}

export const useRoleManager = ({
  role,
  allPermissions,
  currentRolePermissions,
}: UseRoleManagerProps) => {
  const [selectedCodes, setSelectedCodes] = useState<string[]>([]);
  const [groupedPermissions, setGroupedPermissions] =
    useState<GroupedPermissions>({});

  // Khởi tạo data ban đầu
  useEffect(() => {
    setGroupedPermissions(groupPermissionsByModule(allPermissions));
    if (!role) {
      setSelectedCodes([]);
      // setGroupedPermissions({});
    } else {
      const initialCodes = currentRolePermissions?.map(
        (rp) => rp.permissionCode,
      );
      setSelectedCodes(initialCodes);
    }
  }, [allPermissions, currentRolePermissions, role]);

  // Xử lý chọn / bỏ chọn 1 permission
  const togglePermission = (code: string) => {
    setSelectedCodes((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code],
    );
  };

  // Xử lý chọn / bỏ chọn toàn bộ 1 module
  const toggleModule = (moduleName: string, isChecked: boolean) => {
    if (!role) {
      return;
    } else {
      const moduleCodes = groupedPermissions[moduleName].map((p) => p.code);
      setSelectedCodes((prev) => {
        if (isChecked) {
          // Thêm các code chưa có
          const newCodes = moduleCodes.filter(
            (code: string) => !prev.includes(code),
          );
          return [...prev, ...newCodes];
        } else {
          // Xóa các code của module này
          return prev.filter((code) => !moduleCodes.includes(code));
        }
      });
    }
  };

  // Tạo payload chuẩn bị submit
  const getSubmitPayload = (): UpdateRolePermissionPayload => ({
    role,
    permissionCodes: selectedCodes,
  });

  return {
    groupedPermissions,
    selectedCodes,
    togglePermission,
    toggleModule,
    getSubmitPayload,
  };
};
